import React, { Component } from 'react';

import './GovernancaAssembleiaGeral.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import Swipeable from 'react-swipeable';

// import OwlCarousel from 'react-owl-carousel2';
// import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
// import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	views,
	governanca_content
} from '../../settings';

import {
	DelayLink,
	Compromisso
} from '../../components/';

class GovernancaAssembleiaGeral extends Component {

	constructor() {
		super();

        this.images = images;
        this.governanca_content = governanca_content;

        this.state = {
            width: window.innerWidth
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('04 Governança corporativa'); 
    }

    componentWillUnmount() {
	}

    componentDidMount() {
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'assembleiageral'
		];


		// Icon Columns - Assembleia
		const options = {
		    items: 1,
		    nav: true,
		    bullets: true,
		    rewind: true
		};

		const iconsHtml = [];
		for (let i = 0; i < this.governanca_content.razao_existir.length; i++) {
			iconsHtml.push(
				<div key={i} className="icon_columns__column">
					<div className="icon">
						<img src={ this.governanca_content.razao_existir[i].image } />
					</div>
					<div className="content">
		    			<p className="text">{ renderHTML(this.governanca_content.razao_existir[i].text) }</p>
					</div>
				</div>
			);
		}

		var outputIconsHtml;
		if (isMobile) {
			outputIconsHtml = 	<Carousel showStatus={false} showThumbs={false} infiniteLoop={true}>
								    { iconsHtml }
								</Carousel>;
		} else {
			outputIconsHtml = iconsHtml;
		}

        return (

			<div className="views">
			
				<Helmet>
	                <title>4.1 Governança corporativa - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>4.1</span> Governança corporativa</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Governança corporativa</p>
		        			</div>
		        		</header>

		        		<div className="views__content first__view row">
			        		<div className="container">
			        			
				        		<div className="column column--half">
				        			<Fade bottom>
					        			<p className="gri_p">
					        				<span className="gri_label"><text>GRI 102-18</text></span>
					        			</p>
					        			<p className="first_paragraph">
											A estrutura de governança é formada <br />
											por Assembleia, Diretoria e Conselhos Fiscal <br />
											e de Ética – esses três últimos órgãos <br />
											são formados por membros voluntários.  <br />
											<br /><br />
											O modelo de atuação apoia-se no diálogo <br />
											com todos os setores que defendemos para  <br />
											assegurar a legitimidade da  representação.
										</p>
				        			</Fade>
				        		</div>
			        			
				        		<div className="column column--half column--image-full column--image-full-center text-center">
				        			<img src={ this.images.assembleia_geral_img1 } />
				        		</div>

			        		</div>
		        		</div>

		        		<div className="views__content titled_view disclaimer_view row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
					        			<h3 className="titled_view__title titled_view__title--no-line">
					        				Além de participar da Diretoria, os associados atuam voluntariamente em comitês, subcomitês e grupos de trabalho, que ajudam a definir estratégias e objetivos relevantes para o desenvolvimento do mercado. Esses fóruns elaboram iniciativas para:
					        			</h3>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content titled_view two_columns_view row">
			        		<div className="container">
				        		<div className="column column--half">
				        			<Fade bottom>
				        				<h2>Representar</h2>
				        				<p>os interesses dos mercados por meio do diálogo <br />e da cooperação com os setores público e privado.</p>
				        			</Fade>
				        		</div>
			        			
				        		<div className="column column--half">
				        			<Fade bottom>
				        				<h2>Autorregular</h2>
				        				<p>com a criação de regras de boas práticas adotadas <br />voluntariamente pelas instituições que seguem <br />nossos códigos.</p>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content titled_view disclaimer_view row">
			        		<div className="container">
				        		<div className="column column--image-full column--image-full-center">
				        			<Fade bottom>
				        				<img src={ this.images.assembleia_geral_img2 } />
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>


		        		<div className="views__content titled_view disclaimer_view assembleia__view row">
			        		<div className="container">
			        			
				        		<div className="column">
				        			<Fade bottom>
				        				<h2 className="section_title">Assembleia</h2>
					        			<h3 className="titled_view__title titled_view__title--no-line">
					        				O órgão máximo de decisão é a Assembleia, para a qual cada associado indica um membro, de forma que:
					        			</h3>

					        			<p>
					        				<span className="gri_label"><text>GRI 102-22</text></span>
					        			</p>

					        			<div className="icon_columns row"> 
						        			{ outputIconsHtml }
					        			</div>
				        			</Fade>
				        		</div>

			        		</div>
		        		</div>


		        		<div className="views__content titled_view disclaimer_view last__view row">
			        		<div className="container">
			        			
				        		<div className="column column--half column--padding-right">
				        			<Fade bottom>
					        			<h3 className="titled_view__title titled_view__title--no-line">
					        				A Assembleia toma as decisões estratégicas e vota para:
					        			</h3>

					        			<p className="gri_p">
					        				<span className="gri_label"><text>GRI 102-26</text></span>
					        			</p>

					        			<ul>
					        				<li>Eleger e destituir os membros da Diretoria e dos conselhos Fiscal e de Ética;</li>
					        				<li>Deliberar sobre as contas e as demonstrações financeiras;</li>
					        				<li>Aprovar a criação ou alterações em códigos de autorregulação;</li>
					        				<li>Realizar qualquer alteração no Código de Ética.</li>
					        			</ul>
				        			</Fade>
				        		</div>
			        			
				        		<div className="column column--half column--image-full text-center">
				        			<img src={ this.images.assembleia_geral_img3 } />
				        		</div>

			        		</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { GovernancaAssembleiaGeral };
